"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
interface UseAutoSliderProps {
  totalItems: number;
  intervalDuration?: number;
}
export const useAutoSlider = t0 => {
  const $ = _c(6);
  const {
    totalItems,
    intervalDuration: t1
  } = t0;
  const intervalDuration = t1 === undefined ? 4000 : t1;
  const [activeIndex, setActiveIndex] = useState(0);
  let t2;
  let t3;
  if ($[0] !== intervalDuration || $[1] !== totalItems) {
    t2 = () => {
      if (totalItems <= 1) {
        return;
      }
      const interval = setInterval(() => {
        setActiveIndex(prev => (prev + 1) % totalItems);
      }, intervalDuration);
      return () => clearInterval(interval);
    };
    t3 = [totalItems, intervalDuration];
    $[0] = intervalDuration;
    $[1] = totalItems;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== activeIndex) {
    t4 = {
      activeIndex,
      setActiveIndex
    };
    $[4] = activeIndex;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};

// Common Framer Motion Utilities
export const commonTextVariants = {
  initial: {
    opacity: 0,
    y: 30
  },
  animate: {
    opacity: 1,
    y: 0
  },
  exit: {
    opacity: 0,
    y: -30
  }
};
export const commonImageVariants = {
  initial: {
    opacity: 0,
    scale: 0.95
  },
  animate: {
    opacity: 1,
    scale: 1
  },
  exit: {
    opacity: 0,
    scale: 1.05
  }
};